import { createReducer, on } from "@ngrx/store";
import {
  LearnerCourseState,
  initialLearnerCourseState,
} from "./learner-course.state";
import {
  GetLearnerCourseLog,
  GetLearnerCourseLogSuccess,
  GetLearnerCoursesList,
  GetLearnerCoursesListError,
  GetLearnerCoursesListSuccess,
  ReAssignLearnerToAssessment,
  ReAssignLearnerToAssessmentError,
  ReAssignLearnerToAssessmentSuccess,
  GenerateLearningPlan,
  GenerateLearningPlanError,
  GenerateLearningPlanSuccess,
  ResetLearnerCourseState,
  UpdateDisableLearnerCourse,
  UpdateDisableLearnerCourseError,
  UpdateDisableLearnerCourseSuccess,
  GetLearnerCourse,
  GetLearnerCourseSuccess,
  GetLearnerCourseError,
  UpdateLearnerCourse,
  UpdateLearnerCourseSuccess,
  UpdateLearnerCourseError,
  GetLearnerCourseLogError,
  GetLearnersLearnerCourseLogStatus,
  GetLearnersLearnerCourseLogStatusSuccess,
  GetLearnersLearnerCourseLogStatusError,
  AddLearnerCourseList,
  AddLearnerCourseListSuccess,
  AddLearnerCourseListError,
  ResetAddLearnerCourseList,
  GetLearnerCourseScreenerResult,
  GetLearnerCourseScreenerSuccess,
  GetLearnerCourseScreenerError
} from "./learner-course.actions";
import { convertLevelString } from "src/app/shared/results";
import { setTimeFormat } from "src/app/shared/date-and-time-format";
import { DIGITAL_LIT_SA_COURSE_ID } from "src/app/constants/CourseResources";

export const LearnerCourseReducers = createReducer(
  initialLearnerCourseState,
  on(ResetLearnerCourseState, (): LearnerCourseState => {
    return initialLearnerCourseState;
  }),
  on(GetLearnerCoursesList, (state): LearnerCourseState => {
    return {
      ...state,
      loader: true,
      result: null,
    };
  }),
  on(GetLearnerCoursesListSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      loader: false,
      result: action.result.map(r => {
        return {
          ...r,
          screenerResult: r.screenerResult ? {
            ...r.screenerResult,
            overallResult: convertLevelString(r.screenerResult.overallResult),
            totalTime:setTimeFormat(r.screenerResult.totalTime, state.langCode)
          } : r.screenerResult
        }
      }),
    };
  }),
  on(GetLearnerCoursesListError, (state, action): LearnerCourseState => {
    return {
      ...state,
      loader: false,
      result: null,
      error: action.error,
    };
  }),
  on(UpdateDisableLearnerCourse, (state): LearnerCourseState => {
    return {
      ...state,
      messageResult: null,
      updateDisableLoader: true,
    };
  }),
  on(UpdateDisableLearnerCourseSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      messageResult: action.params,
      updateDisableLoader: false,
    };
  }),
  on(UpdateDisableLearnerCourseError, (state, action): LearnerCourseState => {
    return {
      ...state,
      error: action.error,
      updateDisableLoader: false,
    };
  }),
  on(ReAssignLearnerToAssessment, (state): LearnerCourseState => {
    return {
      ...state,
      reAssignError: null,
      reAssignLoader: true,
      reAssignResult: null
    };
  }),
  on(ReAssignLearnerToAssessmentSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      reAssignLoader: false,
      reAssignResult: action.result
    };
  }),
  on(ReAssignLearnerToAssessmentError, (state, action): LearnerCourseState => {
    return {
      ...state,
      reAssignError: action.error,
      reAssignLoader: false
    };
  }),
  on(GenerateLearningPlan, (state): LearnerCourseState => {
    return {
      ...state,
      generateLearningPlanError: null,
      generateLearningPlanLoader: true,
      generateLearningPlanResult: null
    };
  }),
  on(GenerateLearningPlanSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      generateLearningPlanLoader: false,
      generateLearningPlanResult: action.result
    };
  }),
  on(GenerateLearningPlanError, (state, action): LearnerCourseState => {
    return {
      ...state,
      generateLearningPlanError: action.error,
      generateLearningPlanLoader: false
    };
  }),
  on(GetLearnerCourseLog, (state): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLog: null,
      learnerCourseLogLoader: true,
      learnerCourseLogError: null
    };
  }),
  on(GetLearnerCourseLogSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLog: action.result,
      learnerCourseLogLoader: false
    };
  }),
  on(GetLearnerCourseLogError, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLog: null,
      learnerCourseLogLoader: false,
      learnerCourseLogError: action.error
    }
  }),
  on(ReAssignLearnerToAssessmentError, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLogLoader: false,
      learnerCourseLogError: action.error
    };
  }),
  on(GetLearnerCourse, (state): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLoader: true,
      learnerCourse: null,
    };
  }),
  on(GetLearnerCourseSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLoader: false,
      learnerCourse: action.result,
    };
  }),
  on(GetLearnerCourseError, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLoader: false,
      learnerCourse: null,
      learnerCourseError: action.error,
    };
  }),
  on(UpdateLearnerCourse, (state): LearnerCourseState => {
    return {
      ...state,
      updateLearnerCourseResult: null,
      updateLearnerCourseLoader: true,
      updateLearnerCourseError: null,
    };
  }),
  on(UpdateLearnerCourseSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      updateLearnerCourseResult: action.result,
      updateLearnerCourseLoader: false,
    };
  }),
  on(UpdateLearnerCourseError, (state, action): LearnerCourseState => {
    return {
      ...state,
      updateLearnerCourseResult: null,
      updateLearnerCourseLoader: false,
      updateLearnerCourseError: action.error,
    };
  }),
  on(GetLearnersLearnerCourseLogStatus, (state): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLogStatus: null,
      learnerCourseLogStatusLoader: true,
      learnerCourseLogStatusError: null
    };
  }),
  on(GetLearnersLearnerCourseLogStatusSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLogStatus: action.result,
      learnerCourseLogStatusLoader: false
    };
  }),
  on(GetLearnersLearnerCourseLogStatusError, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseLogStatus: null,
      learnerCourseLogStatusLoader: false,
      learnerCourseLogStatusError: action.error
    }
  }),
  on(AddLearnerCourseList, (state): LearnerCourseState => {
    return {
      ...state,
      addLearnerCourseListResult: null,
      addLearnerCourseListLoader: true,
      addLearnerCourseListError: null
    };
  }),
  on(AddLearnerCourseListSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      addLearnerCourseListResult: action.result,
      addLearnerCourseListLoader: false
    };
  }),
  on(AddLearnerCourseListError, (state, action): LearnerCourseState => {
    return {
      ...state,
      addLearnerCourseListResult: null,
      addLearnerCourseListLoader: false,
      addLearnerCourseListError: action.error
    }
  }),
  on(ResetAddLearnerCourseList, (state): LearnerCourseState => {
    return {
      ...state,
      addLearnerCourseListResult: null,
      addLearnerCourseListLoader: false,
      addLearnerCourseListError: null
    }
  }),
  on(GetLearnerCourseScreenerResult, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseScreenerLoader: true,
      learnerCourseScreenerResult: [],
      learnerCourseScreenerError: null,
      langCode: action.langCode
    }
  }),
  on(GetLearnerCourseScreenerSuccess, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseScreenerLoader: false,
      learnerCourseScreenerResult: action.courses.map(r => {
        return {
          ...r,
          screenerResult: r.screenerResult ? {
            ...r.screenerResult,
            overallResult: convertLevelString(r.screenerResult.overallResult),
            totalTime:setTimeFormat(r.screenerResult.totalTime, state.langCode)
          } : r.screenerResult
        }
      }).filter(c => !DIGITAL_LIT_SA_COURSE_ID.includes(c.id))
    }
  }),
  on(GetLearnerCourseScreenerError, (state, action): LearnerCourseState => {
    return {
      ...state,
      learnerCourseScreenerLoader: false,
      learnerCourseScreenerError: action.error
    }
  })
);
